import { propertyFetch } from './idxPropertyClient';
import { SITE_CONFIG } from '../config';

const records = new Map();
const MEDIA_TTL_MS = 60_000;
const FAILURE_RETRY_MS = 5_000;
const recordFor = key => {
  if (!records.has(key)) records.set(key, { media: [], loadedAt: 0, retryAt: 0, pending: null });
  return records.get(key);
};
const order = item => Number.isFinite(Number(item?.order_hint)) ? Number(item.order_hint) : Number.MAX_SAFE_INTEGER;
const usableMedia = media => (Array.isArray(media) ? media : []).filter(item => item &&
  !/tour|video|document|pdf/i.test(`${item.media_category || ''} ${item.content_type || ''}`));
export const propertyMediaUrls = media => [...new Set(usableMedia(media)
  .sort((a, b) => order(a) - order(b))
  .flatMap(item => [item.media_url, item.s3_link, item.image_data &&
    (String(item.image_data).startsWith('data:') ? item.image_data : `data:image/jpeg;base64,${item.image_data}`)])
  .filter(value => typeof value === 'string' && value.trim()))];
const retryDelay = response => {
  const raw = response?.headers?.get?.('Retry-After');
  return raw && /^\d+$/.test(raw) ? Math.max(1, Number(raw)) * 1000 : FAILURE_RETRY_MS;
};
const mediaUrl = key => String(key).startsWith('PRIVATE_')
  ? `https://tophamtechbe.com/api/treas/media/private/v1/media/${encodeURIComponent(SITE_CONFIG.SITE_ID)}/${encodeURIComponent(String(key).slice(8))}`
  : `https://tophamtechbe.com/api/treas/idx/v1/retrieve-property-media/${encodeURIComponent(key)}`;

export function loadPropertyMedia(key, { force = false } = {}) {
  if (!key) return Promise.resolve([]);
  const record = recordFor(key);
  const now = Date.now();
  if (record.pending) return record.pending;
  if (!force && record.loadedAt && now - record.loadedAt < MEDIA_TTL_MS) return Promise.resolve(record.media);
  if (!force && record.retryAt > now) return Promise.resolve(record.media);
  const privateKey = String(key).startsWith('PRIVATE_');
  record.pending = (async () => {
    try {
      const response = await propertyFetch(mediaUrl(key), {
        cache: 'no-store',
        headers: privateKey ? { 'x-api-key': 'treas-api-key-2025' } : {}
      });
      if (!response.ok) {
        record.retryAt = Date.now() + retryDelay(response);
        return record.media;
      }
      const data = await response.json();
      record.media = usableMedia(data.media);
      record.loadedAt = Date.now();
      record.retryAt = 0;
      return record.media;
    } catch (_) {
      record.retryAt = Date.now() + FAILURE_RETRY_MS;
      return record.media;
    } finally {
      record.pending = null;
    }
  })();
  return record.pending;
}

export const __resetPropertyMediaForTests = () => records.clear();
